import { useCallback, useEffect, useRef, useState } from "react";
import { useToastContext } from "../../../contexts/ToastContext/ToastContext";
import { redirectIfUnauthorized } from "../utils/adminUtils";

export class AdminApiError extends Error {
  constructor(code) {
    super(`API error ${code}`);
    this.code = code;
  }
}

// Garante o messageCode de sucesso da API; senão lança AdminApiError com o código recebido
export const expectCode = (res, successCode) => {
  if (res?.messageCode !== successCode) {
    if (res?.messageCode === 500000) console.log(res);
    throw new AdminApiError(res?.messageCode ?? 500000);
  }
  return res;
};

export const getErrorCode = (e) =>
  e instanceof AdminApiError ? e.code : e?.response?.data?.messageCode || 500000;

// Carrega uma lista (load deve devolver um array) com loading, erro e recarga
const useAdminList = (load) => {
  const { showErrorToast } = useToastContext();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);
  const loadRef = useRef(load);
  loadRef.current = load;
  const mountedRef = useRef(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const result = await loadRef.current();
      if (!mountedRef.current) return;
      setItems(Array.isArray(result) ? result : []);
      setLoadError(false);
    } catch (e) {
      if (!mountedRef.current || redirectIfUnauthorized(e)) return;
      console.log(e);
      setLoadError(true);
      showErrorToast({ code: getErrorCode(e) });
    } finally {
      if (mountedRef.current) setLoading(false);
    }
  }, [showErrorToast]);

  useEffect(() => {
    mountedRef.current = true;
    reload();
    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { items, setItems, loading, loadError, reload };
};

export default useAdminList;
